import { Column, RowData, Table, TableFeature } from '@tanstack/react-table';

// Extend Column with label getter/setter
declare module '@tanstack/react-table' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Column<TData extends RowData, TValue> {
    setLabel: (label: string) => void;
    getLabel: () => string | undefined;
  }
}

export const ColumnLabelFeature: TableFeature<any> = {
  createColumn: <TData extends RowData>(column: Column<TData, unknown>, _table: Table<TData>): void => {
    let label: string | undefined = column.columnDef.meta?.label;
    column.setLabel = (newLabel: string) => {
      if (!label) label = newLabel;
    };
    column.getLabel = () => label;
  },
};
